/* istanbul ignore file */

import React from 'react';
import {
  getNothsLogoUrl,
  getNothsRobinLogoUrl,
  getStaticFilesEnv,
} from '@noths/polaris-client-static-files';

import { isChristmasCampaignPeriod } from './isChristmasCampaignPeriod';
import * as styles from './SiteLogo.styles';
import type { Environment } from 'client-site-chrome-ui/environment';

interface SiteLogoProps {
  env: Environment;
}

export const SiteLogo = ({ env = 'production' }: SiteLogoProps) => {
  const staticFilesEnv = getStaticFilesEnv(env);
  const getLogoUrl = isChristmasCampaignPeriod(new Date()) ? getNothsRobinLogoUrl : getNothsLogoUrl;

  return <img alt="" css={styles.image} src={getLogoUrl(staticFilesEnv, '3001')} />;
};
